import { scaleLinear } from 'd3-scale';
import '@d3fc/d3fc-element';
import { seriesSvgPoint } from '@d3fc/d3fc-series';
import {
    OrderFill,
    deriveOrderFillBucketFillPrice,
    deriveOrderFillBucketFillVolume,
    deriveOrderFillBucketMidTime,
} from 'widgets/fillsGraph/fillsGraphData';
/* eslint-disable @typescript-eslint/no-explicit-any */

export const fillVolumeBars = (orderQuantity: number | undefined) => {
    const fillBarSymbol = {
        draw: function (context: CanvasRenderingContext2D, size: number) {
            context.rect(-1, -size / 2, 2, size);
            context.closePath();
        },
    };
    return seriesSvgPoint()
        .mainValue(deriveOrderFillBucketFillPrice)
        .crossValue(deriveOrderFillBucketMidTime)
        .size((d: OrderFill, i: number, nodes: any[]) => {
            const quantityDealt = deriveOrderFillBucketFillVolume(d);
            if (!quantityDealt) {
                return 0;
            }
            let node = nodes[i];
            while (node.tagName !== 'svg') {
                node = node.parentNode;
            }
            const { height } = node.getBoundingClientRect();
            const fillBarScale = scaleLinear()
                .domain([0, orderQuantity || 0])
                .range([0, height]);
            return fillBarScale(quantityDealt);
        })
        .type(fillBarSymbol)
        .decorate((s: any) => s.classed('fillVolumeBar', true));
};
